
import Vue from 'vue';
import authModule, { AuthState } from '@/store/auth-module';

export default Vue.extend({
  name: 'Secured',

  created() {
    if (this.state === 'pending') {
      authModule.dispatch.loadSession();
    }
  },

  data() {
    return {
      error: undefined as undefined | any,
    };
  },

  computed: {
    state(): AuthState {
      return authModule.state.state;
    },
  },

});
